import script from "./AutocompletePriceBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutocompletePriceBox.vue?vue&type=script&setup=true&lang=ts"

import "./AutocompletePriceBox.vue?vue&type=style&index=0&id=fa0f257a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0f257a"]])

export default __exports__